<div class="card shadow-sm border-0 rounded-4">
  <div class="card-body">
    <div style="height: 100%">
      <canvas
        baseChart
        [data]="chartData"
        [options]="chartOptions"
        [type]="'doughnut'">
      </canvas>
    </div>
  </div>
</div>